import { Divider, message, Spin } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import ButtonItem from "../../../../../Components/ButtonItem";
import moment from "moment";
import "moment/locale/es";

class PagoConekta extends Component {
    formRef = React.createRef();

    state = {
        loading: false,
        loadingConekta: false,

        // modo: 'checkout' | 'spei' | 'cash' | 'paid' | 'error'
        modo: "checkout",
        status: null,
        type: null,

        infoTransferencia: null,
        infoEfectivo: null,
    };

    componentDidMount() {
        this.bootstrapPago();
    }

    componentDidUpdate(prevProps) {
        // Si cambia el pagoConektaId, reinicia
        if (prevProps.pagoConektaId !== this.props.pagoConektaId) {
            this.bootstrapPago();
        }
    }

    bootstrapPago = async () => {
        if (!this.props.pagoConektaId) return;

        this.setState({ loadingConekta: true, modo: "checkout" });

        try {

            const res = await axios.post(
                "facturacion/checarStatusPago",
                {
                    empresaId: this.props.empresaId,
                    pagoId: this.props.pagoId,
                },
                { headers: this.props.headersToken }
            );

            if (res.data?.success !== 2) {
                this.setState({ loadingConekta: false, modo: "error" });
                return message.error(res.data?.message || "Error al verificar el status del pago.");
            }

            const status = res.data?.status;
            const type = res.data?.type; // 'spei' | 'cash' | etc.

            // Si ya pagó
            if (status === "paid") {
                this.setState({ loadingConekta: false, modo: "paid", status, type });
                message.success("El pago ya está aplicado. Regrese para aplicar el pago.");
                return this.cerrarPagoConekta();
            }

            // Si ya eligió método y está pendiente, mostramos instrucciones (NO renderizar checkout)
            if (status === "pending_payment" && type === "spei") {
                this.setState({
                    loadingConekta: false,
                    modo: "spei",
                    status,
                    type,
                    infoTransferencia: res.data?.infoTransferencia || {},
                    infoEfectivo: null,
                });
                return;
            }

            if (status === "pending_payment" && type === "cash") {
                this.setState({
                    loadingConekta: false,
                    modo: "cash",
                    status,
                    type,
                    infoEfectivo: res.data?.infoEfectivo || {},
                    infoTransferencia: null,
                });
                return;
            }

            // Para cualquier otro status / sin type: intentamos renderizar checkout
            this.setState(
                { loadingConekta: true, modo: "checkout", status, type },
                () => this.loadConektaScript(this.props.pagoConektaId)
            );
        } catch (err) {
            console.error(err);
            this.setState({ loadingConekta: false, modo: "error" });
            message.error("Error al verificar el pago.");
        }
    };

    loadConektaScript(pagoId) {
        // Si ya existe, solo inicializa
        if (window.ConektaCheckoutComponents?.Integration) {
            this.initializeConektaCheckout(pagoId);
            return;
        }

        // Si ya se está cargando o ya se cargó
        if (document.getElementById("conekta-checkout-script")) {
            // Espera a que cargue (poll simple)
            const t = setInterval(() => {
                if (window.ConektaCheckoutComponents?.Integration) {
                    clearInterval(t);
                    this.initializeConektaCheckout(pagoId);
                }
            }, 150);
            setTimeout(() => clearInterval(t), 6000);
            return;
        }

        const script = document.createElement("script");
        script.id = "conekta-checkout-script";
        script.src = "https://pay.conekta.com/v1.0/js/conekta-checkout.min.js";
        script.async = true;
        script.onload = () => this.initializeConektaCheckout(pagoId);
        script.onerror = () => {
            this.setState({ loadingConekta: false, modo: "error" });
            message.error("No se pudo cargar el script de Conekta.");
        };
        document.body.appendChild(script);
    }

    initializeConektaCheckout(pagoId) {
        // Limpia el contenedor antes de reintegrar
        const el = document.querySelector("#conekta_pago");
        if (el) el.innerHTML = "";

        const options = {
            backgroundMode: "lightMode",
            colorPrimary: "#081133",
            colorText: "#585987",
            colorLabel: "#585987",
            inputType: "minimalMode",
        };

        const config = {
            locale: "es",
            publicKey:
                process.env.NODE_ENV === "development"
                    ? process.env.REACT_APP_CONEKTA_PUBLIC_KEY_DEV
                    : process.env.REACT_APP_CONEKTA_PUBLIC_KEY_PROD,
            targetIFrame: "#conekta_pago",
            checkoutRequestId: pagoId,
        };

        const infoSuccessFunction = () => {
            this.setState({ loadingConekta: false });
        };

        const checarPago = (orderId) => {
            this.setState({ loading: true, loadingConekta: true });

            axios
                .post(
                    "facturacion/checarPago",
                    { empresaId: this.props.empresaId, orderId },
                    { headers: this.props.headersToken }
                )
                .then((res) => {
                    this.setState({ loading: false, loadingConekta: false });

                    if (res.data.success === 2) {
                        message.success("El pago se realizó correctamente.");
                        this.cerrarPagoConekta();
                    } else if (res.data.success === 1) {
                        message.warning(res.data.message);
                    } else {
                        message.error("Error: no se encontró información del pago.");
                    }
                })
                .catch(() => {
                    this.setState({ loading: false, loadingConekta: false });
                    message.error("Error al validar el pago.");
                });
        };

        const callbacks = {
            onGetInfoSuccess: () => infoSuccessFunction(),
            onFinalizePayment: (data) => checarPago(data.id),
            onErrorPayment: (error) => {
                console.log("error en pago: ", error);
            },
        };

        window.ConektaCheckoutComponents.Integration({
            config,
            callbacks,
            options,
        });
    }

    cerrarPagoConekta() {
        this.props.cerrarPagoConekta();
    }

    copyToClipboard = async (text, label = "Copiado") => {
        try {
            await navigator.clipboard.writeText(String(text || ""));
            message.success(label);
        } catch (e) {
            message.error("No se pudo copiar.");
        }
    };

    renderSpei() {
        const t = this.state.infoTransferencia || {};
        const card = {
            background: "#fff",
            border: "1px solid #eaeaea",
            borderRadius: 14,
            padding: 18,
            boxShadow: "0 10px 30px rgba(0,0,0,.06)",
            margin: "10px 0 18px",
        };
        const title = { fontSize: 18, fontWeight: 700, color: "#111827", marginBottom: 8 };
        const sub = { fontSize: 13, color: "#6b7280", marginBottom: 14 };
        const row = {
            display: "flex",
            justifyContent: "space-between",
            gap: 12,
            padding: "10px 12px",
            borderRadius: 12,
            border: "1px solid #f0f0f0",
            background: "#fafafa",
            marginBottom: 10,
            alignItems: "center",
            flexWrap: "wrap",
        };
        const k = { fontSize: 12, color: "#6b7280" };
        const v = { fontSize: 14, fontWeight: 700, color: "#111827", wordBreak: "break-all" };

        return (
            <div style={card}>
                <div style={title}>Transferencia (SPEI) pendiente</div>
                <div style={sub}>
                    Usa los siguientes datos para realizar la transferencia. Después puedes volver y presionar “Ya pagué” para validar.
                </div>

                <div style={row}>
                    <div>
                        <div style={k}>CLABE</div>
                        <div style={v}>{t.clabe || "—"}</div>
                    </div>
                    <ButtonItem onClick={() => this.copyToClipboard(t.clabe, "CLABE copiada")}>
                        Copiar
                    </ButtonItem>
                </div>

                <div style={row}>
                    <div>
                        <div style={k}>Referencia / Concepto</div>
                        <div style={v}>{t.concepto || "—"}</div>
                    </div>
                    <ButtonItem onClick={() => this.copyToClipboard(t.concepto, "Referencia copiada")}>
                        Copiar
                    </ButtonItem>
                </div>

                <div style={row}>
                    <div>
                        <div style={k}>Vigencia</div>
                        <div style={v}>{t.fechaExpiracion
                            ? moment.unix(t.fechaExpiracion).format("DD/MM/YYYY HH:mm")
                            : "—"}</div>
                    </div>
                </div>

                <div style={{ display: "flex", gap: 10, flexWrap: "wrap", marginTop: 10 }}>
                    <ButtonItem type="primary" onClick={this.bootstrapPago}>
                        Ya pagué (validar)
                    </ButtonItem>
                    <ButtonItem onClick={this.bootstrapPago}>
                        Actualizar
                    </ButtonItem>
                </div>
            </div>
        );
    }

    renderCash() {
        const c = this.state.infoEfectivo || {};

        const card = {
            background: "#fff",
            border: "1px solid #eaeaea",
            borderRadius: 14,
            padding: 18,
            boxShadow: "0 10px 30px rgba(0,0,0,.06)",
            margin: "10px 0 18px",
        };
        const title = { fontSize: 18, fontWeight: 700, color: "#111827", marginBottom: 8 };
        const sub = { fontSize: 13, color: "#6b7280", marginBottom: 14 };
        const row = {
            display: "flex",
            justifyContent: "space-between",
            gap: 12,
            padding: "10px 12px",
            borderRadius: 12,
            border: "1px solid #f0f0f0",
            background: "#fafafa",
            marginBottom: 10,
            alignItems: "center",
            flexWrap: "wrap",
        };
        const k = { fontSize: 12, color: "#6b7280" };
        const v = { fontSize: 14, fontWeight: 700, color: "#111827", wordBreak: "break-all" };

        const storeNames = Array.isArray(c.storeNames) ? c.storeNames.join(", ") : c.storeNames;

        const imprimirBarcode = () => {
            if (!c.barcode_url) return;
            const w = window.open("", "_blank", "width=800,height=900");
            if (!w) return;

            w.document.write(`
      <html>
        <head>
          <title>Código de barras</title>
          <style>
            body { font-family: Arial, sans-serif; padding: 24px; }
            .wrap { max-width: 520px; margin: 0 auto; text-align: center; }
            img { width: 100%; height: auto; border: 1px solid #eaeaea; border-radius: 12px; padding: 12px; }
            .hint { margin-top: 12px; color: #6b7280; font-size: 12px; }
          </style>
        </head>
        <body>
          <div class="wrap">
            <h2>Código de barras</h2>
            <img src="${c.barcode_url}" alt="Código de barras" />
            <div class="hint">Si no se ve, usa “Abrir” y vuelve a intentar.</div>
          </div>
          <script>
            window.onload = function () { window.print(); };
          </script>
        </body>
      </html>
    `);
            w.document.close();
        };

        return (
            <div style={card}>
                <div style={title}>Pago en efectivo pendiente</div>
                <div style={sub}>
                    Presenta la referencia y el código de barras en tienda para realizar el pago.
                    Después puedes volver y presionar “Ya pagué” para validar.
                </div>

                <div style={row}>
                    <div>
                        <div style={k}>Referencia</div>
                        <div style={v}>{c.referencia || "—"}</div>
                    </div>
                    <ButtonItem onClick={() => this.copyToClipboard(c.referencia, "Referencia copiada")}>
                        Copiar
                    </ButtonItem>
                </div>

                <div style={row}>
                    <div>
                        <div style={k}>Tiendas</div>
                        <div style={v}>{storeNames || "—"}</div>
                    </div>
                </div>

                <div style={row}>
                    <div>
                        <div style={k}>Vigencia</div>
                        <div style={v}>  {c.fechaExpiracion
                            ? moment.unix(c.fechaExpiracion).format("DD/MM/YYYY HH:mm")
                            : "—"}</div>
                    </div>
                </div>

                {/* ✅ Código de barras en pantalla */}
                {c.barcode_url ? (
                    <div
                        style={{
                            border: "1px solid #f0f0f0",
                            borderRadius: 14,
                            background: "#fff",
                            padding: 14,
                            marginTop: 12,
                        }}
                    >
                        <div style={{ ...k, marginBottom: 8 }}>Código de barras</div>

                        <div
                            style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                background: "#fafafa",
                                border: "1px solid #eaeaea",
                                borderRadius: 12,
                                padding: 14,
                                overflow: "hidden",
                            }}
                        >
                            <img
                                src={c.barcode_url}
                                alt="Código de barras para pago en efectivo"
                                style={{ maxWidth: "100%", height: "auto" }}
                                onError={() => message.warning("No se pudo cargar el código de barras. Usa 'Abrir código'.")}
                            />
                        </div>

                        <div style={{ display: "flex", gap: 10, flexWrap: "wrap", marginTop: 12 }}>
                            <ButtonItem type="primary" onClick={() => window.open(c.barcode_url, "_blank")}>
                                Abrir código
                            </ButtonItem>
                            <ButtonItem onClick={imprimirBarcode}>
                                Imprimir código
                            </ButtonItem>
                        </div>
                    </div>
                ) : null}

                <div style={{ display: "flex", gap: 10, flexWrap: "wrap", marginTop: 14 }}>
                    <ButtonItem type="primary" onClick={this.bootstrapPago}>
                        Ya pagué (validar)
                    </ButtonItem>

                    <ButtonItem onClick={this.bootstrapPago}>Actualizar</ButtonItem>
                </div>
            </div>
        );
    }


    render() {
        const { modo, loadingConekta } = this.state;

        return (
            <Spin tip="Cargando pago..." spinning={loadingConekta}>
                {/* Contenido principal */}
                <div style={{ padding: 10 }}>
                    {modo === "spei" ? this.renderSpei() : null}
                    {modo === "cash" ? this.renderCash() : null}

                    {/* Checkout solo si modo checkout */}
                    {modo === "checkout" ? (
                        <div id="conekta_pago" style={{ height: "650px", padding: 0 }} />
                    ) : null}

                    {modo === "error" ? (
                        <div
                            style={{
                                background: "#fff",
                                border: "1px solid #ffd4d4",
                                borderRadius: 14,
                                padding: 18,
                                boxShadow: "0 10px 30px rgba(0,0,0,.06)",
                                margin: "10px 0 18px",
                            }}
                        >
                            <div style={{ fontSize: 18, fontWeight: 700, color: "#7f1d1d" }}>
                                No se pudo cargar el pago
                            </div>
                            <div style={{ fontSize: 13, color: "#6b7280", marginTop: 6 }}>
                                Intenta nuevamente. Si el problema persiste, revisa el ID de la orden y la conexión con Conekta.
                            </div>
                            <div style={{ marginTop: 12 }}>
                                <ButtonItem type="primary" onClick={this.bootstrapPago}>
                                    Reintentar
                                </ButtonItem>
                            </div>
                        </div>
                    ) : null}
                </div>

                <p style={{ color: "#333", marginBottom: "1em", marginLeft: "1em", fontSize: ".8rem" }}>
                    <strong>Factura</strong> la factura se emitirá automáticamente
                </p>

                <Divider style={{ color: "black", borderColor: "black", marginBottom: "1em", marginTop: "1em" }} />

                <ButtonItem
                    type="primary"
                    danger
                    style={{ marginBottom: "2em" }}
                    onClick={this.cerrarPagoConekta.bind(this)}
                >
                    Regresar
                </ButtonItem>
            </Spin>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        headersToken: state.user.headersToken,
        usuarioId: state.user.usuarioId,
    };
};

export default connect(mapStateToProps)(PagoConekta);
